import { Controller } from "stimulus"
import Choices from 'choices.js'

export default class extends Controller {
  static targets = [ "select", "form", "childSelect" ]
  static values = { childId: String }

  connect() {
    // this.choicesInstance = new Choices(this.element.querySelector('select'), {
    //   removeItemButton: true
    // })

    if (this.hasSelectTarget) {
      this.choicesInstance = new Choices(this.selectTarget, {
        removeItemButton: true
      })
      this.selectTarget.choiceControl = this.choicesInstance
    }
  }

  parentChanged(event) {
    const selectedValue = event.target.value
    const selectedOption = event.target.options[event.target.selectedIndex];
    const eventformat = selectedOption.dataset.eventformat;

    const customData = this.choicesInstance.customProperties;

    console.log(customData)

    // Dispatch custom event
    const customEvent = new CustomEvent('parent-select-changed', {
      detail: { 
        value: selectedValue,
        childId: this.childIdValue 
      }
    })
    
    window.dispatchEvent(customEvent)
  }
  
  handleParentChange(event) {
    const { value, childId } = event.detail

    // Only respond if this is the intended child
    if (childId && this.element.id !== childId) return

    this.choicesInstance.setChoiceByValue("4")
  }
  
  disconnect() {
    if (this.choicesInstance) {
      this.choicesInstance.destroy()
    }
  }

  submit() {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }
}
